import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

function Limitation({ value = null, title }) {
  numeral.localeData().delimiters.thousands = ' '

  return (
    <p className="text-light-grey">
      <strong>{`${typeof value === 'string' ? value : numeral(value).format('0,0')} `}</strong>
      {title}
    </p>
  )
}

Limitation.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Limitation
